import { ColorType } from "lightweight-charts";
import { IStockChartDataRequest } from "../../interfaces/StockChartData.interface";

export const sharesColors = {
  orange: "#fcd362",
  navyBlue: "#4a6784",
  blue: "#74a9f2",
  pinkPastel: "#ffa7C7",
  brown: "#dd8b6a",
  yellow: "#faba0a",
  lightBlue: "#d3dae1",
  black: "#1a1a1a",
  greyCloud: "#f2f2f2",
  white: "#ffffff",
  greenDeep: "#067161",
  red: "#660000",
};
export const chartOptions = {
  height: 225,
  grid: {
    vertLines: { visible: true, color: sharesColors.greyCloud },
    horzLines: { visible: true, color: sharesColors.greyCloud },
  },
  watermark: {
    visible: false,
  },
  layout: {
    fontSize: 12,
    lineHeight: 16,
    fontColor: sharesColors.black,
    family: "Rubik",
    textColor: sharesColors.black,
    background: { type: ColorType.Solid, color: sharesColors?.white },
  },
  handleScroll: false,
  handleScale: false,
  timeScale: {
    timeVisible: true,
    secondsVisible: false,
    ticksVisible: false,
    rightOffset: 1,
    borderColor: "transparent",
    fixLeftEdge: true,
    fixRightEdge: true,
    minimumHeight: 0,
  },
  crosshair: {
    horzLine: {
      visible: false,
      labelVisible: false,
    },
    vertLine: {
      labelVisible: false,
    },
  },
  rightPriceScale: {
    borderColor: sharesColors.greyCloud,
  },
  leftPriceScale: {
    borderColor: sharesColors.greyCloud,
  },
};
export const graphDurationBtns = ["1D", "5D", "1M", "3M", "6M", "1Y"];
export const durationIntervalValue = {
  "1D": "1",
  "5D": "60",
  "1M": "D",
  "3M": "D",
  "6M": "W",
  "1Y": "W",
};
export const graphOptionData: Partial<IStockChartDataRequest> = {
  fromDate: new Date().toISOString().slice(0, 10),
  toDate: new Date().toISOString().slice(0, 10),
  interval: "1",
};
